import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonObservableService {
  filterTriggered: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false,
  );

  setFilterTriggeredData(data: boolean) {
    this.filterTriggered.next(data);
  }

  getFilterTriggeredData(): Observable<boolean> {
    return this.filterTriggered.asObservable();
  }

  filterFormData: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  setFilterFormData(data: any) {
    this.filterFormData.next(data);
  }

  getFilterFormData(): Observable<any> {
    return this.filterFormData.asObservable();
  }

  constructor() {}
}
